import { Outlet } from 'react-router-dom';
import { Box, Theme, Typography } from '@mui/material';
import PaginationProvider from '../../providers/PaginationProvider';
import SettlementsTable from './SettlementsTable';
import { makeStyles } from 'tss-react/mui';
import DeductionsTable from './DeductionsTable';
import ClientsTable from './ClientsTable';

const useStyles = makeStyles()((theme: Theme) => ({
    systemAccountContainer: {
        display: 'flex',
        flexDirection: 'column',
        gap: theme.spacing(2),
        width: '100%',
    },
    systemAccountsBlockLabel: {
        fontSize: '15px',
        fontWeight: 400,
        lineHeight: '120%',
        color: theme.palette.text.disabled,
        fontFamily: 'Poppins',
        marginBottom: '12px',
        display: 'flex',
        alignItems: 'center',
        gap: '4px'
    },
    tableLabel: {
        fontSize: '20px',
        fontWeight: 600,
        lineHeight: '120%',
        color: theme.palette.common.white,
        fontFamily: 'Poppins',
    },
}));

const DashboardView = () => {
    const { classes } = useStyles();
    // const showApprovalFlow = localStorage.getItem('hasSettlementApprovalFlow') === 'true';
    const showUserOnboardingDetails = localStorage.getItem('showUserOnboardingDetails') === 'true';

    return (
        <>
            <Box className={classes.systemAccountContainer}>
                <Typography className={classes.systemAccountsBlockLabel} >

                    <span>{localStorage.getItem('userName')}</span>
                    <span>&middot;</span>
                    <span>{localStorage.getItem('userRole')}</span>
                </Typography>


                {/* The dashboard Settlements section is no longer tied to the settlement approval flag.
                {showApprovalFlow && (
                    <PaginationProvider key='draftSettlementsTable1'>
                        <SettlementsTable />
                    </PaginationProvider>)}
                */}
                <PaginationProvider key='draftSettlementsTable1'>
                    <SettlementsTable />
                </PaginationProvider>


              {showUserOnboardingDetails &&
                <PaginationProvider key='clientsTable'>
                    <ClientsTable />
                </PaginationProvider>}



                <PaginationProvider key='deductionsTable'>
                    <DeductionsTable />
                </PaginationProvider>

            </Box>
            <Outlet />
        </>
    );
};

export default DashboardView;
